import classNames from "classnames/bind";
import type {
    ResolvedItem,
    ResolvedStaticPageComponentWrapper,
} from "resolvers/data/staticPageComponentWrapperResolver";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

import InvestorAnnouncements from "../InvestorAnnouncements";
import SharePrice from "../SharePrice";
import StaticCard from "../StaticCardList/StaticCard";
import styles from "./StaticPageComponentWrapper.module.scss";

const cx = classNames.bind(styles);

const getComponent = (resolvedItem: ResolvedItem) => {
    if (!resolvedItem) return <></>;

    switch (resolvedItem.type) {
        case ContentTypeCodenames.SharePrice:
            return <SharePrice {...resolvedItem} />;

        case ContentTypeCodenames.StaticCard:
            return <StaticCard {...resolvedItem} />;

        case ContentTypeCodenames.InvestorAnnouncements:
            return <InvestorAnnouncements {...resolvedItem} />;

        default:
            return <></>;
    }
};

const StaticPageComponentWrapper = (props: ResolvedStaticPageComponentWrapper) => {
    return (
        <div className={cx("static-page-component-wrapper")}>
            {props.resolvedItems.map((item) => getComponent(item))}
        </div>
    );
};

export default StaticPageComponentWrapper;
